import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import PaymentIcon from '@material-ui/icons/Payment'
import { FlexDataItem } from 'components/FlexDataView'
import Typography from '@material-ui/core/Typography'
import { Progress } from './Progress'
import StyleSheet from 'styles'
import {NumberDisplay} from 'components/numbers'

export class Payment extends PureComponent {
  static propTypes = {
    dealSheet: PropTypes.object
  }

  render = () => {
    const {dealSheet} = this.props
    return (
      <FlexDataItem>
        <Typography variant='subtitle1'><PaymentIcon />Payment</Typography>
        <dl>
          <dt>Payment Expected</dt>
          <dd><NumberDisplay prefix={dealSheet.currency.prefix} suffix={dealSheet.currency.code}>{dealSheet.paymentExpected}</NumberDisplay></dd>
          <dt>Payment Received</dt>
          <dd><NumberDisplay prefix={dealSheet.currency.prefix} suffix={dealSheet.currency.code}>{dealSheet.paymentReceived}</NumberDisplay></dd>
        </dl>
        <Progress className={styles.progress} value={dealSheet.amountClaimed} total={dealSheet.amountAllocated} totalLabel="Expected" valueLabel="Received" showKey/>
      </FlexDataItem>
    )
  }
}

const styles = StyleSheet({
  progress: {
    marginLeft: 15,
    marginRight: 15,
  }
})